export class OfferFilter {
    name: string;
    pesel: string;
    status: string;
    createdFrom: string
    createdTo: string;
    number: string;
    branch: string;
    agency: string;
    seller: string;

    limit = 100;
    offset = 0;
}


export class PolicyFilter {
    number: string;
    name: string;
    pesel: string;
    insurancePeriodFrom: string
    insurancePeriodTo: string;
    issuanceDateFrom: string
    issuanceDateTo: string;
    agency: string;
    seller: string;
    licensePlate: string;
    vin: string;
}


